import { Dict, SfFormFieldErrorCode } from "@/types/generalTypes";

const errors = {
  required: "This field is required",
  invalidEmail: "Invalid email address",
  match: "Values don't match",
  minLength: "Value is too short",
  minValue: "Value is too low",
  exists: "Alrady exists",
  invalid: "Invalid value",
};

export default function (
  code: SfFormFieldErrorCode,
  customErrors: Dict<string> | null,
) {
  if (customErrors && customErrors[code]) {
    return customErrors[code];
  }
  return errors[code];
}
